import moment from 'moment'

const BrowserFS = require('browserfs')
const storeName = 'CallLogReport'

let fs
let logData
let fileName

BrowserFS.install(window)

const create = () => {
  fileName = `/[${storeName}]${moment(new Date()).format('YYYY-MM-DD')}.txt`
  if (BrowserFS) {
    BrowserFS.configure({fs: 'IndexedDB', options: { storeName: storeName }}, err => {
      fs = window.require('fs')
      if (!err) {
        unlink()
        fs.readFile(fileName, 'utf8', (err, data) => {
          if (err) {
            logData = `### ${storeName} : ${moment(new Date()).format('YYYY-MM-DD')} ###\n`
          } else {
            logData = data
          }
        })
      }
    })
  }
}

const write = (text) => {
  if (fs) {
    logData += `${moment(new Date()).format('HH:mm:ss')} ${text}\n`
    fs.writeFile(fileName, logData, 'utf8', (err) => {
      if (!err) {
        fs.readFile(fileName, 'utf8', (err, data) => {
          if (!err) {
            logData = data
          }
        })
      }
    })
  }
}

const download = (key) => {
  return new Promise((resolve, reject) => {
    fs.readFile(`/[${storeName}]${key.substr(1).replace(/\*/g, '-')}.txt`, 'utf8', (err, data) => {
      if (err) {
        reject(err)
      } else {
        let body = document.body
        let a = document.createElement('a')
        a.href = URL.createObjectURL(new Blob([data], {
          type: 'text/plain'
        }))
        a.setAttribute('download', fileName.substr(1))
        body.appendChild(a)
        a.click()
        body.removeChild(a)
        resolve()
      }
    })
  })
}

const unlink = () => {
  fs.readdir('/', (err, files) => {
    if (!err) {
      const maxSize = 3
      let fileSize = files.length
      if (fileSize > maxSize) {
        files.forEach(file => {
          if (fileSize > maxSize) {
            fs.unlink(file)
            fileSize = fileSize - 1
          }
        })
      }
    }
  })
}

export default {
  create,
  write,
  download
}



// WEBPACK FOOTER //
// ./src/util/logReport.js